// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EventQuickModal_wrapper__20tBz","details_action":"EventQuickModal_details_action__2QsA_"};